var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-404"}},[_c('div',{staticClass:"fof"},[_c('h1',[_vm._v("Error 404")]),_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }